import { render, staticRenderFns } from "./allsubscripe.vue?vue&type=template&id=3816f388&scoped=true&"
import script from "./allsubscripe.vue?vue&type=script&lang=js&"
export * from "./allsubscripe.vue?vue&type=script&lang=js&"
import style0 from "./allsubscripe.vue?vue&type=style&index=0&id=3816f388&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3816f388",
  null
  
)

export default component.exports